import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/view/home';
import MemberLogin from '@/view/member/login';
import MemberRegister from '@/view/member/register';
import PersonInfo from '@/view/member/person-info';
import OrderList from '@/view/member/order-list';
import OrderDetail from '@/view/member/order-detail';
import BookingOrderDetail from '@/view/member/booking-order-detail';
import CartList from '@/view/member/cart-list';
import Cart from '@/view/member/cart';
import ProductList from '@/view/product/product-list';
import ProductDetail from '@/view/product/product-detail';
import ProductSearch from '@/view/product/product-search';
import SalesList from '@/view/sales/sales-list';
import BookingList from '@/view/booking/booking-list';
import FastBooking from '@/view/booking/fast-booking';
import AboutUs from '@/view/about/about';
import ContactUs from '@/view/contact/contact';
import Pay from '@/view/member/pay';
import FavList from '@/view/product/fav-list';
import Notice from '@/view/notice/notice';
// import NoticeDetails from '@/view/notice/notice-details.vue';
// import RefundList from '@/view/refund/refund-list';
import LogisticsList from '@/view/member/logistics-list.vue';
import DeliveryList from '@/view/delivery-list/delivery-list.vue';
import DeliveryDetails from '@/view/delivery-list/delivery-list-details.vue';
import DepositList from '@/view/member/deposit-list.vue';
import OrderConfirm from '@/view/member/order-confirm.vue';
// import RefundList from '@/view/refund/refund-list';
import Invoice from '@/view/member/invoice.vue';
import NoDepositList from '@/view/no-deposit-list/index.vue';
import IntentionList from '@/view/intention-list/index.vue';
import IntentionDetail from '@/view/intention-list/intention-detail.vue';
import NoDepositDetail from '@/view/no-deposit-list/no-deposit-detail.vue';

Vue.use(Router);

export default new Router({
    routes: [
        //首页
        { path: '/', name: 'Home', component: Home },
        // 会员中心
        { path: '/member/login', name: 'MemberLogin', component: MemberLogin },
        { path: '/member/register', name: 'MemberRegister', component: MemberRegister },
        { path: '/member/person-info', name: 'PersonInfo', component: PersonInfo },
        { path: '/member/order-list', name: 'OrderList', component: OrderList },
        { path: '/member/order-detail', name: 'OrderDetail', component: OrderDetail },
        { path: '/member/booking-order-detail', name: 'BookingOrderDetail', component: BookingOrderDetail },
        { path: '/member/cart-list', name: 'CartList', component: CartList },
        { path: '/member/cart', name: 'Cart', component: Cart },
        { path: '/member/pay', name: 'Pay', component: Pay },
		{ path: '/member/logistics-list', name: 'LogisticsList', component: LogisticsList },
		{ path: '/member/invoice', name: 'Invoice', component: Invoice },
        //产品目录
        { path: '/product/product-list', name: 'ProductList', component: ProductList },
        { path: '/product/product-detail', name: 'ProductDetail', component: ProductDetail },
        { path: '/product/product-search', name: 'ProductSearch', component: ProductSearch },
        { path: '/product/fav-list', name: 'FavList', component: FavList },
        // 现售
        { path: '/sales/sales-list', name: 'SalesList', component: SalesList },
        // 预售
        { path: '/booking/booking-list', name: 'BookingList', component: BookingList },
        { path: '/booking/fast-booking', name: 'FastBooking', component: FastBooking },
        // 余额提现
        // { path:'/refund/Refund-list', name:'RefundList', component:RefundList },
        // 缤纷简介
        { path: '/about/about', name: 'AboutUs', component: AboutUs },
        // 联系我们
        { path: '/contact/contact', name: 'ContactUs', component: ContactUs },
		//公告
		{ path: '/notice/notice', name: 'Notice', component: Notice },
		// 公告详情
		// { path: '/notice/notice-details', name: 'NoticeDetails', component: NoticeDetails }
		// 公告详情
		// { path: '/notice/notice-details', name: 'NoticeDetails', component: NoticeDetails }
		//发货单
		{ path: '/delivery-list/delivery-list', name: 'DeliveryList', component: DeliveryList },
		//发货单详情
		{ path: '/delivery-list/delivery-list-details', name: 'DeliveryDetails', component: DeliveryDetails },
		//订金单列表
        { path: '/member/deposit-list', name: 'DepositList', component: DepositList },
        //支付订金
        { path: '/member/order-confirm', name: 'OrderConfirm', component: OrderConfirm },
		//待支付列表
		{ path: '/member/no-deposit-list', name: 'NoDepositList', component: NoDepositList },
        //意向单
		{ path: '/member/intention-list', name: 'IntentionList', component: IntentionList },
        //意向单详情
		{ path: '/member/intention-detail', name: 'IntentionDetail', component: IntentionDetail },
		//待支付详情
		{ path: '/member/no-deposit-detail', name: 'NoDepositDetail', component: NoDepositDetail }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js